module.exports = __webpack_public_path__ + "static/img/c-bg1.306764b1.png";